import { TranslateLoader } from '@ngx-translate/core';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { Observable } from 'rxjs';

export class CustomTranslateLoader implements TranslateLoader {
  constructor(
    private landingModelService: LandingModelService
  ) {}

  public getTranslation(): Observable<any> {
    return new Observable(subscriber =>  subscriber.next(this.getTranslationObject()));
  }

  private getTranslationObject(): any {
    return this.landingModelService.getLandingModel().i18n;
  }
}
